app.service('productTabMatches',function(loading, productCardConfig, console, cartManager) {
	var $self, $list, $categories, $moreCategoriesButton, config;

	function load(groupId) {
		loading.start();
		var data={
			'product-link-name':config.linkName,
			'group-id':groupId,
		};

		$.ajax({
			url:'/product-card-matches-to.ltr',
			data:data,
			success:function(html){
				loadSuccess(html);
			},
			error:function(){
				console.log('Błąd ładowania akcesorii');
			}
		});
	}
	function loadSuccess(html) {
		$list.html(html);
		$self.productSlider();
		loading.stop();
		checkCart();
	}
	function checkCart() {
		cartManager.checkRelatedProducts();
	}
	function addToCartClick(id, checked) {
		cartManager.clickRelatedProducts(id, checked, 'ACCESS_CARD', config.plu);
	}
	function changeGroupClick(group) {
		load(group);
		selectNewGroup(group);
	}
	function selectNewGroup(group) {
		$categories.filter('.active').removeClass('active').addClass('inactive');
		$categories.filter('[data-group='+group+']').removeClass('inactive').addClass('active');
	}
	function showMoreCategories() {
		$self.addClass('show-all-categories');
	}
	function setEvents(){
		$self.on('click', '.js-add-accessory-to-cart-checkbox', function(event){
			addToCartClick($(this).val(), $(this).is(':checked'));
		});
		$self.on('click', '.js-category-access', function(event){
			UA.interaction('KP', 'Pasuje do', 'Wybór grupy akcesoryjnej - ' + $(this).text().trim());
			changeGroupClick($(this).data('group'));
		});
		$(document).on('cartReady', function(){
			checkCart();
		});
		$moreCategoriesButton.on('click', function(event){
			showMoreCategories();
		});
		$self.on('click', '.js-product-slider-previous', function(){
			UA.interaction('KP', 'Pasuje do', 'Karuzela - Lewo');
		});
		$self.on('click', '.js-product-slider-next', function(){
			UA.interaction('KP', 'Pasuje do', 'Karuzela - Prawo');
		});
	}
	function setElements() {
		$self = $('#matches');
		$list = $('.js-accessories-list', $self);
		$categories=$('.js-category-access', $self);
		$moreCategoriesButton = $('.js-category-access-more', $self);
		$self.productSlider();
		config=productCardConfig.getData();
	}
	function init() {
		setElements();
		setEvents();
	}
	return {
		init:init
	};
});
